// components/ImageGrid/GridPlaceholderCell.jsx
import "./ImageGrid.css";
import { hexToRgba } from "../../utils/couleurs";
import { shuffleArray } from "../../utils/arrayUtils";
import { COLORS } from "../../constants/colors";

const GridPlaceholderCell = () => {
  return (
    <div
      className="grid-cell grid-placeholder"
      style={{ backgroundColor: hexToRgba(shuffleArray(COLORS)[0], 0.15) }}
    />
  );
};

/*
import { ReactComponent as PlaceholderIcon } from "../../assets/domologo.svg";

const GridPlaceholderCell = () => (
  <div className="grid-cell grid-placeholder">
    <PlaceholderIcon className="placeholder-svg" />
  </div>
);
*/

export default GridPlaceholderCell;
